import React from 'react';
import { Box, Text } from 'grommet';
import useSWR from 'swr';
import { goneQuietSummary } from '../../utils/chart-data';
import { nonRedirectFetcher } from '../../utils/errors';
import { formatCurrencySI } from '../../utils/numbers';
import ChartCard from './ChartCard';
import ChartLink from './ChartLink';
import ChartList from './ChartList';
import ChartRow from './ChartRow';
import { ChartRowsSkeleton } from './ChartSkeleton';

const VIEW_CUSTOMERS = <ChartLink href="/customers" label={<Text size="small" color="text-weak">View customers</Text>} />;

// Regular customers who have stopped ordering, money first. Only worth a card when there are some,
// so a new merchant's dashboard isn't padded with an empty one.
const GoneQuiet = ({ currency, rows = 5 }) => {
    const { data, isLoading } = useSWR(
        '/api/reports/gone-quiet?limit=5',
        nonRedirectFetcher,
        { revalidateOnFocus: false, shouldRetryOnError: false },
    );

    if (isLoading) {
        return <ChartCard title="Gone quiet" action={VIEW_CUSTOMERS}><ChartRowsSkeleton track rows={rows} /></ChartCard>;
    }

    const customers = (data?.data || []).slice(0, rows);
    if (customers.length === 0) return null;

    return (
        <ChartCard title="Gone quiet" action={VIEW_CUSTOMERS}>
            <Box gap="small">
                <Text weight={500}>{goneQuietSummary(data.customer_count, formatCurrencySI(data.yearly_spend_total, currency))}</Text>
                <ChartList>
                    {customers.map((customer) => (
                        <ChartRow
                            key={customer.uuid}
                            name={customer.name}
                            value={`${formatCurrencySI(customer.yearly_spend, currency)}/yr`}
                            href={`/customers/${customer.uuid}`}
                            event={{ section: 'gone_quiet', element: 'row' }}
                        >
                            <Text size="small" color="text-weak">{`No order in ${customer.days_quiet} days, usually every ${customer.usual_gap_days}`}</Text>
                        </ChartRow>
                    ))}
                </ChartList>
            </Box>
        </ChartCard>
    );
};

export default GoneQuiet;
